import { render, staticRenderFns } from "./EditTask.vue?vue&type=template&id=6e210126"
import script from "./EditTask.vue?vue&type=script&lang=js"
export * from "./EditTask.vue?vue&type=script&lang=js"
import style0 from "./EditTask.vue?vue&type=style&index=0&id=6e210126&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports